<template>
  <div :class="$style.container">
    <div :class="$style.titleWrapper">
      <div v-if="titleIconName" :class="$style.icon">
        <NsIcon :icon-name="titleIconName" />
      </div>
      <span :class="$style.title">{{ title }}</span>
    </div>
    <div :class="$style.subtitle">{{ subtitle }}</div>
  </div>
</template>

<script>
import { NsIcon } from "@nuskin/ns-icon";

export default {
  name: "NsSectionHeader",
  components: { NsIcon },
  props: {
    /**
     * The subtitle text
     */
    subtitle: {
      type: String,
      default: ""
    },
    /**
     * Title text
     */
    title: {
      type: String,
      default: ""
    },
    /**
     * The type of accent icon next to the title
     */
    titleIcon: {
      type: String,
      default: "",
      validator: value =>
        ["arrow", "heart", "spark", "squiggle", "star"].includes(value)
    }
  },
  computed: {
    titleIconName() {
      switch (this.titleIcon) {
        case "arrow":
          return "icon-freeland-arrow";
        case "heart":
          return "icon-freeland-heart";
        case "spark":
          return "icon-spark-left-24";
        case "squiggle":
          return "icon-freeland-squiggle";
        case "star":
          return "icon-freeland-star";
        default:
          return "";
      }
    }
  }
};
</script>

<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";

.container,
.container * {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.container {
  margin: 40px auto 20px;
  max-width: 600px;
}

.titleWrapper {
  @include global.title-bold-italic-caps;
  color: map.get(colors.$themeColors, color-primary-text);
  text-align: center;
  letter-spacing: 1.5px;
}
.title {
  @include global.title-bold-italic-caps;
  letter-spacing: 1.5px;
}
.icon {
  position: relative;
  top: 3px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
  width: 20px;
  height: 20px;
}

.subtitle {
  @include global.p-large;
  margin-top: 15px;
  color: map.get(colors.$themeColors, color-primary-text);
}

@media (min-width: 768px) {
  .subtitle {
    @include global.p-medium;
  }
}
</style>
